export const en = {
  properties: {
    title: 'Properties',
    position: 'Position',
    x: 'X Position',
    y: 'Y Position',
    rotation: 'Rotation',
    color: 'Color',
    number: 'Number',
    name: 'Name',
    team: 'Team',
    otherNumber: 'Other number...',
    size: {
      title: 'Size',
      small: 'Small',
      medium: 'Medium',
      large: 'Large'
    },
    visibility: {
      show: 'Show',
      hide: 'Hide',
      toggleAll: 'All'
    },
    actions: {
      applyToAll: 'Apply to all',
      delete: 'Delete',
      lockPosition: 'Lock position'
    }
  },
  toolbar: {
    newPage: 'New page',
    open: 'Load',
    save: 'Save',
    addPlayer: 'Add player',
    addBall: 'Add ball',
    addZone: 'Add zone',
    addArrow: 'Add arrow',
    editField: 'Edit field',
    exportVideo: 'Export to video',
    exportImage: 'Export to PNG',
    backgroundColor: 'Background color',
    changeLanguage: 'Change language',
    login: 'Login',
    logout: 'Logout',
    fullscreen: 'Fullscreen'
  },
  mobile: {
    rotateDevice: 'Please rotate your device to landscape mode'
  },
  panels: {
    pitch: {
      title: 'Field Configuration',
      type: {
        title: 'Field Type',
        label: 'Field Type',
        full: 'Full field',
        half: 'Half field'
      },
      side: {
        label: 'Field Side',
        left: 'Left',
        right: 'Right'
      },
      display: {
        title: 'Display Options',
        medianLine: 'Median Line',
        centralCircle: 'Central Circle',
        centralPoint: 'Central Point',
        penaltyArea: 'Penalty Area',
        penaltyAreaArcs: 'Penalty Area Arcs',
        penaltyPoints: 'Penalty Points',
        goalArea: 'Goal Area',
        goals: 'Goals',
        cornerArcs: 'Corner Arcs',
        halfSpaces: 'Half Spaces'
      }
    },
    zone: {
      title: 'Zone',
      opacity: 'Opacity',
      fill: 'Fill Color',
      borderStyle: 'Border Style',
      strokeWidth: 'Border Width',
      strokeOpacity: 'Border Opacity',
      draggable: 'Draggable',
      lock: 'Lock Zone',
      strokeColor: 'Stroke Color',
      fillColor: 'Fill Color',
      fillOpacity: 'Fill Opacity',
      dashArray: 'Line Style',
      solid: 'Solid',
      dashed: 'Dashed',
      dotted: 'Dotted',
      lockPosition: 'Lock Position',
      delete: 'Delete Zone'
    },
    player: {
      title: 'Player'
    },
    ball: {
      title: 'Ball',
      size: 'Size',
      color: 'Color',
      strokeColor: 'Stroke color',
      hideStroke: 'Hide stroke'
    },
    arrow: {
      title: 'Arrow',
      strokeWidth: 'Stroke width',
      strokeOpacity: 'Stroke opacity',
      borderStyle: 'Border style',
      color: 'Color',
      styles: {
        solid: 'Solid',
        dashed: 'Dashed',
        dotted: 'Dotted'
      }
    },
    training: {
      title: 'Equipment',
      items: {
        cone: 'Cone',
        mannequin: 'Mannequin',
        goal: 'Goal',
        ladder: 'Ladder',
        hoop: 'Hoop',
        disc: 'Disc',
        hurdle: 'Hurdle',
        pole: 'Pole',
        miniGoal: 'Mini goal'
      },
      step: 'Step',
      steps: {
        one: 'Step 1',
        two: 'Step 2',
        three: 'Step 3',
        four: 'Step 4',
        five: 'Step 5'
      }
    },
    trainingItem: {
      title: 'Edit',
      color: 'Color',
      size: 'Size',
      rotation: 'Rotation',
      fineRotation: 'Fine rotation'
    }
  },
  landing: {
    hero: {
      title: {
        part1: "The simplest and fastest tool",
        part2: "to generate",
        part3: "videos of"
      },
      words: {
        videos: "RONDOS",
        sequences: "SEQUENCES",
        compositions: "COMPOSITIONS",
        exercises: "EXERCISES",
        cpa: "SET-PIECES",
        games: "GAMES"
      },
      cta: "Start for free",
      login: "Login"
    },
    sections: {
      video: {
        title: "See TacticaFoot in action"
      },
      exercises: {
        title: "Create your exercises",
        cta: "Discover"
      },
      sessions: {
        title: "Organize your sessions",
        cta: "Learn more"
      },
      present: {
        title: "Present",
        cta: "Try now"
      },
      share: {
        title: "Share",
        cta: "Join",
        login: "Login"
      },
      pricing: {
        title: "Our Pricing",
        regularPrice: "€65 / year",
        specialOffer: "Special Offer",
        specialPrice: "€37 / year",
        payButton: "Subscribe"
      },
      why: {
        title: 'Why TACTICAFOOT',
        features: {
          simple: {
            title: 'Simple',
            description: 'TacticaFoot is so simple you already know how to use it'
          },
          sync: {
            title: 'Synchronized',
            description: 'Access your tactics on all your devices'
          },
          rapide: {
            title: 'Fast',
            description: 'The fastest app to generate videos or images'
          },
          puissant: {
            title: 'Powerful',
            description: 'Give your team superpowers'
          },
          accessible: {
            title: 'Accessible',
            description: 'TacticaFoot is available everywhere, no installation needed'
          },
          secure: {
            title: 'Secure',
            description: 'Your data is protected and backed up'
          },
          intuitif: {
            title: 'Intuitive',
            description: 'A fluid interface designed for coaches'
          },
          evolutif: {
            title: 'Evolving',
            description: 'Improvements every week'
          },
          collab: {
            title: 'Collaborative',
            description: 'Send videos and images to your teams or staff'
          }
        }
      }
    },
    nav: {
      discover: 'Discover',
      pricing: 'Pricing',
      contact: 'Contact'
    }
  },
  footer: {
    rights: 'All rights reserved',
    contact: 'Contact',
    legal: 'Legal notice',
    otherTools: {
      title: 'Other tools',
      features: 'Team management, Exercise library, Match and training management, Team selection, Attendance tracking'
    }
  },
  signup: {
    title: {
      step1: 'Create account',
      step2: 'Complete registration'
    },
    fields: {
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      club: 'Club',
      phone: 'Phone',
      password: 'Password',
      marketingSource: 'How did you hear about us?'
    },
    country: 'Country',
    language: 'Language',
    buttons: {
      validate: 'Validate',
      signup: 'Sign up'
    },
    consent: 'I agree to receive news from Tacticafoot.',
    success: {
      title: 'Registration successful!',
      message: 'A confirmation email has been sent. Please check your inbox.',
      cta: 'Access tutorial'
    },
    errors: {
      required: 'This field is required',
      consent: 'You must agree to receive news',
      emailInUse: 'An account already exists with this email address.',
      registration: 'Error during registration'
    }
  },
  login: {
    title: 'Login',
    fields: {
      email: 'Email',
      password: 'Password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      rememberMe: 'Remember me'
    },
    buttons: {
      login: 'Login',
      forgotPassword: 'Forgot password?',
      signup: 'Create account'
    },
    errors: {
      invalidEmail: 'Invalid email address',
      userDisabled: 'This account has been disabled',
      userNotFound: 'No account found with this email address',
      wrongPassword: 'Incorrect password',
      default: 'An error occurred during login'
    },
    resetPassword: {
      title: 'Reset password',
      description: 'Enter your email address and we will send you a link to reset your password.',
      button: 'Send link',
      cancel: 'Cancel',
      success: 'Email sent! Check your inbox.',
      error: 'Error sending email. Please check your email address.'
    }
  }
};
